import React from 'react';
import { Bar } from '@nivo/bar';
import { useTextMeasurer } from 'helpers/dom';
import { Loading } from 'e4shared';

export const CompletionRate = ({ data, consts, divHeight }) => {
    const [mappedData, setMappedData] = React.useState([]);
    const [width, setWidth] = React.useState(0);

    const truncate = useTextMeasurer('12px sans-serif');

    React.useEffect(() => {
        const temp = data.map(d => ({ location: d.x, value: ((d.z ? d.y / d.z : 0) * 100).toFixed() }));
        setMappedData(temp.sort((a, b) => (a.location > b.location ? -1 : 1)));
    }, [data]);

    React.useEffect(() => {
        if (data?.length) {
            const parent = document.getElementById(consts.parent);
            setWidth(parent.offsetWidth);
        }
    }, [data]);

    if (!width) {
        return <Loading />;
    }

    return (
        <div style={data.length > 10 ? { height: `${divHeight(mappedData)}px`, overflowY: 'auto' } : null}>
            <Bar
                data={mappedData}
                indexBy="location"
                keys={['value']}
                colors={['#94B263']}
                borderRadius={4}
                layout="horizontal"
                enableGridX={true}
                gridXValues={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                enableGridY={false}
                valueFormat={x => `${(x * 100).toFixed()}%`}
                height={divHeight(mappedData, true)}
                width={width - consts.leftMargin}
                padding={consts.padding}
                margin={{ top: 0, right: 30, bottom: consts.axisHeight, left: consts.leftMargin }}
                valueScale={{
                    type: 'linear',
                    min: 0,
                    max: 100,
                    clamp: true, // Prevents bars from overflowing
                }}
                axisBottom={{
                    tickValues: [0, 20, 40, 60, 80, 100],
                    tickSize: 0,
                    tickPadding: 5,
                    tickRotation: 0,
                    format: x => `${x}%`,
                }}
                axisLeft={{
                    renderTick: tick => (
                        <g dominantBaseline="central" transform={`translate(${tick.x},${tick.y})`}>
                            <text
                                transform={`translate(-${consts.leftMargin}, 0)`}
                                textAnchor="left" // Ensures left-aligned text
                                style={{
                                    color: '#333',
                                    fontSize: 11,
                                }}
                            >
                                {truncate(tick.value, consts.leftMargin - 5)}
                            </text>
                        </g>
                    ),
                }}
                enableLabel={false} // disable default labels
                layers={[
                    'grid',
                    'axes',
                    'bars',
                    'markers',
                    'legends',
                    'annotations',
                    props => {
                        // custom label layer
                        return props.bars.map(bar => (
                            <text
                                key={bar.key}
                                x={bar.x + bar.width + 3} // place text 3px after bar end
                                y={bar.y + bar.height / 2 + 1}
                                textAnchor="start"
                                alignmentBaseline="middle"
                                style={{
                                    fill: '#333',
                                    fontSize: 11,
                                    fontWeight: 600,
                                }}
                            >
                                {bar.data.value > 0 ? `${bar.data.value}%` : null}
                            </text>
                        ));
                    },
                ]}
                tooltip={({ id, value, color, indexValue }) => <span>{`${indexValue}: ${value}%`}</span>}
            />
        </div>
    );
};

export default CompletionRate;
